export default {
  pluginId: 'manage-assets',
  defaultPageName: 'default',
  defaultPageId: 'manage-asset-list',
  typeName: 'ManageAsset',
  baseUrl: '/content-api',
};
